import React from 'react';
import { Header as SemanticHeader, HeaderProps } from 'semantic-ui-react';

type Props = {
  content?: string;
  extra?: React.ReactNode;
} & HeaderProps;

const Header: React.FC<Props> = ({ children, content, extra, ...rest }) => {
  return (
    <SemanticHeader className={`typography_header`} content={content} {...rest}>
      {children} {extra}
    </SemanticHeader>
  );
};

export default Header;
